module.exports = __webpack_public_path__ + "static/media/rabobank.13cec97d.png";